import { Button, Checkbox, Menu, Popover, PopoverInteractionKind } from '@blueprintjs/core';
import React from 'react';
import {
    checkboxesContainerDiv, displayFlex, filterPopoverSubtitle, minimalistFilterButton, popoverSettings,
    stateCheckbox, statesFiltersContainer, tripStatusMenuTag
} from '../../styles';


export const getTripStatus = (tripStatusOptionsCheckboxs) => {
    const selectedStatus = tripStatusOptionsCheckboxs.filter(statusOption => statusOption.isChecked);
    let isFirst = true;
    let tripStatus = '';

    selectedStatus.forEach(status => {
        if (isFirst) {
            tripStatus += status.value;
            isFirst = false;
        } else {
            tripStatus += "," + status.value
        }
    });

    return tripStatus;
};


export default class TripStatusFilterModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            tripStatusCheckboxs: this.props.fatherComponent.state.tripStatusCheckboxs,
        }
    }

    state = {
        tripStatusCheckboxs: [],
    }

    handleTripStatusOptionsChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var tripStatusCheckboxs = this.state.tripStatusCheckboxs;

        const selectedTripStatus = tripStatusCheckboxs.filter(tripStatus => tripStatus.isChecked === true);

        if (selectedTripStatus.length === 1 && selectedTripStatus[0].name === name) {
            return;
        }

        tripStatusCheckboxs.forEach(tripStatus => {
            if (tripStatus.name === name) {
                tripStatus.isChecked = value
            }
        });

        this.setState({
            tripStatusCheckboxs: tripStatusCheckboxs
        })
    }


    render() {

        return (
            <Popover
                position="bottom-left"
                style={popoverSettings}
                captureDismiss={true}
                canEscapeKeyClose={true}
                interactionKind={PopoverInteractionKind.CLICK}
                content={
                    <Menu style={tripStatusMenuTag}>
                        <div style={checkboxesContainerDiv}>
                            <div style={displayFlex}>
                                <div style={statesFiltersContainer}>
                                    <h4 style={filterPopoverSubtitle}>
                                        <u>Select all that apply:</u>
                                    </h4>
                                    {this.state.tripStatusCheckboxs.map(tripStatusOptions => {
                                        return (
                                            <Checkbox
                                                inline
                                                key={tripStatusOptions.name}
                                                name={tripStatusOptions.name}
                                                checked={tripStatusOptions.isChecked}
                                                label={tripStatusOptions.label}
                                                onChange={this.handleTripStatusOptionsChange}
                                                style={stateCheckbox}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </Menu>
                }>
                <Button style={minimalistFilterButton} intent={'primary'} icon="filter" />
            </Popover>
        )
    }
}


